<template>
  <section class="section" :class="{ 'section-stretch': stretch }">
    <div class="container intro-layout">
      <aside v-reveal class="side-nav">
        <h3>{{ $pick(sideTitle) }}</h3>
        <router-link
          v-for="item in items"
          :key="item.path"
          :class="{ active: $route.path === item.path }"
          :to="item.path"
        >
          {{ $pick(item.label) }}
        </router-link>
      </aside>
      <div v-reveal class="content-pane">
        <div class="breadcrumb">{{ breadcrumbLabel }}{{ $pick(breadcrumb) }}</div>
        <h2>{{ $pick(title) }}</h2>
        <p v-for="paragraph in paragraphs" :key="$pick(paragraph)">{{ $pick(paragraph) }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PageIntro",
  props: {
    sideTitle: [String, Object],
    items: Array,
    breadcrumb: [String, Object],
    title: [String, Object],
    paragraphs: Array,
    stretch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    breadcrumbLabel() {
      return this.locale === "zh-CN" ? "当前位置：" : "Location: ";
    }
  }
};
</script>

<style scoped>
.intro-layout {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 28px;
}

.side-nav {
  padding: 24px;
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
}

.side-nav h3 {
  margin: 0 0 18px;
  color: var(--brand-blue-deep);
  font-size: 20px;
}

.side-nav a {
  display: block;
  margin-bottom: 10px;
  padding: 12px 14px;
  background: #f5f8fc;
  color: #39495c;
}

.side-nav a.active,
.side-nav a:hover {
  background: var(--brand-blue);
  color: #fff;
}

.content-pane {
  padding: 28px 30px;
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
}

.breadcrumb {
  margin-bottom: 18px;
  color: #8a94a3;
  font-size: 13px;
}

.content-pane h2 {
  margin: 0 0 16px;
  color: var(--brand-blue-deep);
  font-size: 30px;
}

.content-pane p {
  margin: 0 0 14px;
  line-height: 1.9;
  color: #4b5563;
}

.section-stretch .intro-layout {
  min-height: clamp(420px, 56vh, 760px);
  align-items: stretch;
}

.section-stretch .content-pane {
  min-height: 100%;
}

@media (max-width: 900px) {
  .intro-layout {
    grid-template-columns: 1fr;
  }

  .section-stretch .intro-layout {
    min-height: 0;
  }
}

@media (max-width: 520px) {
  .side-nav,
  .content-pane {
    padding: 20px 18px;
  }

  .side-nav {
    display: grid;
    gap: 8px;
  }

  .side-nav h3 {
    margin-bottom: 8px;
    font-size: 18px;
  }

  .side-nav a {
    margin-bottom: 0;
    padding: 11px 12px;
  }

  .breadcrumb {
    line-height: 1.6;
  }

  .content-pane h2 {
    font-size: 24px;
    line-height: 1.28;
  }

  .content-pane p {
    font-size: 14px;
    line-height: 1.85;
  }
}
</style>
